import React, { useEffect } from 'react';
import { getResponseErrorMessage } from '../../../../utils/errors';

const GoogleOAuthCallback = () => {
  useEffect(() => {
    const hasAuthError = new URLSearchParams(window.location.search).has("auth_error");
    if (hasAuthError) {
      return;
    }

    const url = window.location.href;
    fetch(url)
      .then(async res => {
        if (!res.ok) {
          throw new Error(await getResponseErrorMessage(res));
        }
        return res.json();
      })
      .then(data => {
        if (
          data.error === 'Company not found. Please provide Company Name and Country'
        ) {
          localStorage.setItem('showGoogleModal', '1');
          const stillHasAuthError = new URLSearchParams(window.location.search).has("auth_error");
          if (!stillHasAuthError) {
            window.location.replace('/signup');
          }
        } else {
          localStorage.removeItem('showGoogleModal');
        }
      })
      .catch(() => {
        localStorage.setItem('showGoogleModal', '1');
        const stillHasAuthError = new URLSearchParams(window.location.search).has("auth_error");
        if (!stillHasAuthError) {
          window.location.replace('/signup');
        }
      });
  }, []);

  return <div>Authorization via Google...</div>;
};

export default GoogleOAuthCallback;
